var _desc, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextLevelButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 204 57",
    height: 55,
    width: 202,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fillRule: "evenodd",
    fill: "none",
    strokeWidth: 1,
    stroke: "none",
    id: "nextlevelButton_1587580159163"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 1.000000)",
    id: "BUTTON_1587580159163"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2,
    fill: "#000000",
    strokeWidth: 2.5,
    stroke: "#000000",
    id: "SHADOW_1587580159163",
    d: "M118.802734,7.00341797 C98.6145203,7.21807207 73.8488345,7.30317752 51.7114258,7.68135899 C32.6557614,8.00689389 16.1523997,8.89465337 6.16052941,13.4675759 C-1.5951086,17.0170547 -0.259827445,32.2256903 0.860425281,39.3592654 C3.90821561,51.4628605 14.6550097,50.1917898 43.9443359,51.137207 C75.6112891,52.1593706 125.147933,51.7958252 149.878906,51.137207 C176.385219,49.6952265 197.072733,48.3659039 197.844811,37.0525314 C198.150826,32.5684446 198.624474,17.4716246 192.456913,13.4675759 C176.688936,5.36605795 143.981858,7.25039978 118.802734,7.00341797 Z",
    vectorEffect: "non-scaling-stroke"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2880B2",
    strokeWidth: 2.5,
    stroke: "#000000",
    id: "STROKE_99fb390a-b112-4495-90fb-e96524237ba6_1587580159163",
    d: "M118.802734,1.00341797 C98.6145203,1.21807207 73.8488345,1.30317752 51.7114258,1.68135899 C32.6557614,2.00689389 16.1523997,2.89465337 6.16052941,7.46757587 C-1.5951086,11.0170547 -0.259827445,26.2256903 0.860425281,33.3592654 C3.90821561,45.4628605 14.6550097,44.1917898 43.9443359,45.137207 C75.6112891,46.1593706 125.147933,45.7958252 149.878906,45.137207 C176.385219,43.6952265 197.072733,42.3659039 197.844811,31.0525314 C198.150826,26.5684446 198.624474,11.4716246 192.456913,7.46757587 C176.688936,-0.633942047 143.981858,1.25039978 118.802734,1.00341797 Z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    stroke: "#1F6389",
    id: "Path_1587580159163",
    d: "M14,37.6389711 C22.9154866,39.8413225 33.7317984,39.6455044 44.9780273,40.034668 C54.9789471,40.380739 65.6159929,40.7910156 75.5727539,40.7910156 C104.720516,40.7797916 159.066426,42.1158192 182.079548,36.3016168 C192.121824,33.7644633 193,30.2141885 193,24.564375 C193,21.1629801 192.214926,14.1855159 188.650223,12",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    stroke: "#3B9CD3",
    id: "Path_1587580159163",
    d: "M182.785645,9.40283203 C181.789144,8.88728124 177.509976,8.1003811 169.948143,7.04213161 C154.359863,5.47400116 136.962601,5.82132648 121.976563,5.7734375 C92.8762177,5.48816406 60.909668,5.48816406 25.5756836,8.07568359 C10.8379532,10.21108 5.00519001,10.3397702 5.00519001,22.3629059 C4.89077331,30.7609035 6.66814382,35.3066015 10.3373016,36",
    vectorEffect: "non-scaling-stroke"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextLevelButton);
export default __webpack_public_path__ + "static/media/nextLevelButton.4161b91bbbf9494392ef9c3f056ed44e.svg";
export { ForwardRef as ReactComponent };